import { format } from 'date-fns';
import { TrashIcon } from '@heroicons/react/24/outline';
import type { Note } from '@core/generated/gql-types';

interface NoteItemProps {
  note: Note;
  isDeleting?: boolean;
  onDelete?: (noteId: string) => void;
}

const NoteItem = ({ note, isDeleting = false, onDelete }: NoteItemProps) => {
  const ownerEmail = note.ownerEmail ?? 'Unknown user';
  const createdDate = format(
    new Date(Number(note.createdAt)),
    'dd/MM/yyyy h:mma',
  );

  return (
    <article className="flex items-start justify-between gap-4">
      <div className="min-w-0 flex-1">
        <p className="text-sm whitespace-pre-wrap text-gray-800">
          {note.content}
        </p>
        <p className="mt-2 text-xs text-gray-500">
          {ownerEmail} - {createdDate}
        </p>
      </div>
      {onDelete && (
        <button
          aria-label="Delete note"
          className="shrink-0 cursor-pointer rounded-md border border-gray-300 bg-white p-2 text-gray-500 hover:bg-gray-50 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isDeleting}
          onClick={() => onDelete(note.id)}
          type="button"
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      )}
    </article>
  );
};

export default NoteItem;
